import { render, staticRenderFns } from "./headFirstWidget.vue?vue&type=template&id=52a319ed&scoped=true"
import script from "./headFirstWidget.vue?vue&type=script&lang=js"
export * from "./headFirstWidget.vue?vue&type=script&lang=js"
import style0 from "./headFirstWidget.vue?vue&type=style&index=0&id=52a319ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a319ed",
  null
  
)

export default component.exports